












































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import UiList from '@superUI/List/List'
import Modal from '@/components/Modal'
import AddSecretBrandTriggerModal from '@ui/triggers/SecretBrand/AddSecretBrandTriggerModal'
import RemoveSecretBrandTriggerModal from '@ui/triggers/SecretBrand/RemoveSecretBrandTriggerModal'

settings =
  name: 'SecretBrandList'
  components: {
    SuperContainerView,
    UiList,
    Modal,
    AddSecretBrandTriggerModal,
    RemoveSecretBrandTriggerModal,
  }

  resources:
    secret_brands:
      resourceName: 'secret_brand'
      slug: 'marketplace/settings/secret_brands'
      infinityScroll: false

  vue:
    computed:
      hasSecretBrands: -> @secret_brands?.length

    methods:
      hiAddSecretBrandTrigger: ->
        @$refs.addSecretBrandTrigger.fire()
      onSecretBrandsAddSecretBrand: ->
        @fetch 'secret_brands'
        @fetchMarketplaceConfig()
        @$refs.addSecretBrandTrigger.close()

      hiRemoveSecretBrandTrigger: (brand) ->
        payloadOptions = { domain: brand.domain }
        @$refs.removeSecretBrandTrigger.fire payloadOptions
      onSecretBrandsRemoveSecretBrand: ->
        @fetch 'secret_brands'
        @fetchMarketplaceConfig()
        @$refs.removeSecretBrandTrigger.close()

export default VueOptions.vue settings
